import React from 'react';
import Logo from '../../../components/Logo';
import MenuList from './MenuList';

export default function Sidebar() {
  return (
    <div className="h-full flex flex-col py-4 px-3 backdrop-blur-lg bg-white/10 border-r border-white/10 text-white">
      {/* Logo */}
      <div className="mb-6">
        <Logo height={10} />
      </div>

      {/* Menu */}
      <MenuList />
    </div>
  );
}